import React, { useState, memo } from 'react';
import Modal, { ModalProps } from './Modal';

const useModal = () => {
  const [open, setOpen] = useState(false);
  const closeModal = () => setOpen(false);
  const openModal = () => setOpen(true);

  const ModalWrapper = memo(({ children, ...props }: ModalProps) => (
    <Modal {...props} isOpen={open} closeModal={closeModal}>
      {children}
    </Modal>
  )) as any;

  return { Modal: ModalWrapper, closeModal, openModal };
};

export default useModal;
